<p-button 
    icon="fas fa-pen"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Edit')"
    tooltipPosition="left"
    (onClick)="onClick()" />